export enum ContinuityEventType {
  ORDINARY = 'CONTINUITY_ORDINARY',
  EXTRAORDINARY = 'CONTINUITY_EXTRAORDINARY',
}

export enum ContinuityProcessStatus {
  PENDING = 'PENDING',
  IN_PROCESS = 'IN_PROCESS',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAID = 'PAID',
  ENROLLED = 'ENROLLED',
}

export enum ContinuityEventStatus {
  ACTIVE = 'ACTIVE',
  FUTURE = 'FUTURE',
  PAST = 'PAST',
  NO_LIQUIDATION = 'NO_LIQUIDATION',
  NO_EVENT = 'NO_EVENT',
}

export interface ContinuityStatusResponse {
  eventStatus: ContinuityEventStatus;
  eventType: ContinuityEventType | null;
  startDate: string | null;
  endDate: string | null;
  hasLiquidation: boolean;
  hasActiveProcess: boolean;
  processId: number | null;
  currentStep: string | null;
  academicCalendarId: number | null;
  studyPlanEnrollmentId: number | null;
  matriculaOnlineUrl: string;
}

export interface CreditsSummaryData {
  creditsRecommended: number;
  creditsToEnroll: number;
  creditsFrozen: number;
  creditsToPay: number;
  frozenCreditsPaidPrice: number;
  frozenCreditsCurrentPrice: number;
  frozenCreditsDifference: number;
}

export interface ReliquidationCourse {
  name: string;
  credits: number;
  semesterName: string;
}

export interface CreditsSummaryResponse {
  summary: CreditsSummaryData;
  reliquidationCourses: ReliquidationCourse[];
  hasReliquidationRequest: boolean;
  reliquidationRequestStatus: string | null;
}

export interface StudentFileData {
  program: {
    name: string;
    level: string;
    campus: string;
    schedule: string;
    periodOfEntry: string;
  };
  personal: {
    names: string;
    firstSurname: string;
    secondSurname: string;
    idType: string;
    idNumber: string;
    email: string;
    phone: string;
  };
  contact: {
    address: string;
    city: string;
    region: string;
  };
  emergencyContact: {
    name: string;
    phone: string;
    relationship: string;
  };
  familyGroup: {
    members: Record<string, unknown>[];
  };
  healthCare: {
    provider: string;
    plan: string;
  };
}

export interface TuitionValueData {
  paymentDetail: {
    program: string;
    campus: string;
    schedule: string;
    creditsToContract: number;
    tuitionAmount: number;
  };
  frozenCreditsDetail: {
    count: number;
    paidPrice: number;
    currentPrice: number;
    difference: number;
  } | null;
  otherConcepts: { label: string; amount: number }[];
  availableDiscounts: {
    id: number;
    name: string;
    code: string;
    percentage: number;
  }[];
  requestedBenefits: {
    simple: Record<string, unknown>[];
    subsidy: Record<string, unknown>[];
  };
  discountedPayment: {
    originalAmount: number;
    otherConceptsAmount: number;
    totalAmount: number;
    discount: number;
    conventionDiscount: number;
    subsidyDiscount: number;
    finalAmount: number;
  };
  educationalBenefits: Record<string, unknown>[];
  onRevision: boolean;
  areBenefitsPending: boolean;
}

export interface DocumentationData {
  documents: {
    id: number;
    code: string;
    name: string;
    required: boolean;
    uploaded: boolean;
    fileUrl: string | null;
  }[];
}

export interface PaymentData {
  items: { label: string; amount: number }[];
  discounts: { label: string; amount: number }[];
  total: number;
  status: 'pending' | 'processing' | 'approved' | 'rejected' | 'not_found';
  voucherEnabled: boolean;
}

export interface FinancialBlockageResponse {
  blocked: boolean;
  message: string | null;
}
